export default __webpack_public_path__ + "static/media/info-law.c68838c9.jpg";